import React from 'react';
import { cn } from '../../utils/cn';
import type { StackProps } from '../../types/components';

const spacingClasses = {
  sm: 'gap-2',
  md: 'gap-4',
  lg: 'gap-6',
  xl: 'gap-8',
};

const alignClasses = {
  start: 'items-start',
  center: 'items-center',
  end: 'items-end',
  stretch: 'items-stretch',
};

const justifyClasses = {
  start: 'justify-start',
  center: 'justify-center',
  end: 'justify-end',
  between: 'justify-between',
  around: 'justify-around',
  evenly: 'justify-evenly',
};

export const Stack = React.forwardRef<HTMLDivElement, StackProps>(
  (
    {
      direction = 'column',
      spacing = 'md',
      align = 'stretch',
      justify = 'start',
      wrap = false,
      children,
      className,
      testId,
      ...props
    },
    ref
  ) => {
    const baseClasses = ['flex'];
    
    const spacingClass = spacingClasses[spacing] || spacingClasses.md;
    const alignClass = alignClasses[align] || alignClasses.stretch;
    const justifyClass = justifyClasses[justify] || justifyClasses.start;

    const classes = cn(
      baseClasses,
      spacingClass,
      alignClass,
      justifyClass,
      {
        'flex-col': direction === 'column',
        'flex-row': direction === 'row',
        'flex-wrap': wrap,
      },
      className
    );

    return (
      <div
        ref={ref}
        className={classes}
        data-testid={testId}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Stack.displayName = 'Stack';